import React from 'react';
import { getLanguageLevelMeta, getLanguageMeta } from '../../utils/languageDisplay';
import '../Popups/LanguageManageModal.css';
import './ProfilePortfolioSections.css';

type LanguageRow = {
  language?: string;
  level?: string;
};

type ProfileLanguageDisplayProps = {
  languages: LanguageRow[];
};

const ProfileLanguageDisplay: React.FC<ProfileLanguageDisplayProps> = ({ languages }) => {
  if (!languages.length) {
    return (
      <p className="profile-section-empty mb-0">
        Add the languages you know and your proficiency level.
      </p>
    );
  }

  return (
    <ul className="profile-languages-list">
      {languages.map((item, index) => {
        const meta = getLanguageMeta(item.language || '');
        const levelMeta = getLanguageLevelMeta(item.level || '');
        const levelClass = levelMeta?.modalClass ?? 'lang-level-unset';

        return (
          <li key={`${item.language}-${index}`} className={`profile-language-row ${levelClass}`}>
            <span className="languages-avatar">{meta.code}</span>
            <div className="profile-language-copy">
              <div className="profile-language-name">{item.language}</div>
              <div className="profile-language-level">{item.level?.trim() || 'Set fluency'}</div>
            </div>
            <div className="languages-progress-wrap profile-language-progress">
              <div className="languages-progress-track">
                <div
                  className="languages-progress-fill"
                  style={{ width: `${levelMeta?.progress ?? 0}%` }}
                />
              </div>
              <span className="languages-progress-label">
                {levelMeta ? `${levelMeta.progress}%` : '—'}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ProfileLanguageDisplay;
